import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { filter, fromEvent, Subscription } from 'rxjs';
import SwiperCore, { SwiperOptions, Navigation, Pagination } from 'swiper';
import { testimonials } from 'src/app/constants/testimonials';
import {
  awardsGallery,
  workshopsGallery,
  videoGallery,
} from 'src/app/constants/gallery';
import { userSVG } from 'src/app/constants/svgs/user';

SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedIndex = 0;
  userSVG = userSVG;
  testimonials = testimonials;
  galleryConfig = [
    {
      label: 'states.all',
      content: [...awardsGallery, ...workshopsGallery, ...videoGallery],
    },
    {
      label: 'gallery.workshops',
      content: workshopsGallery,
    },
    {
      label: 'gallery.awards',
      content: awardsGallery,
    },
    {
      label: 'gallery.videos',
      content: videoGallery,
    },
  ];

  testimonialSliderConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: true,
    pagination: { clickable: true },
    mousewheel: true,
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      480: {
        slidesPerView: 1.5,
      },
    },
  };
  gallerySliderConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: true,
    pagination: { clickable: true },
    mousewheel: true,
  };

  private aboutUsScrollSubs!: Subscription;
  private isScrolled = false;
  private title = 'About UMANG';
  private description =
    'UMANG (Unified Mobile Application for New-age Governance) is developed by Ministry of Electronics and Information Technology (MeitY) and National e-Governance Division (NeGD) to drive Mobile Governance in India.';

  @ViewChild('contactUs', { static: true }) private contactUsRef!: ElementRef;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private titleService: Title,
    private metaService: Meta,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.setTitleAndMeta();
  }

  ngAfterViewInit() {
    this.listenWindowScroll();
  }

  private setTitleAndMeta() {
    this.titleService.setTitle(this.title);
    this.metaService.updateTag({
      name: 'description',
      content: this.description,
    });
  }

  private listenWindowScroll() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    // Only scroll to contact-us when window is scrolled to top
    this.aboutUsScrollSubs = fromEvent(window, 'scroll')
      .pipe(
        filter(
          () =>
            this.activatedRoute.snapshot.fragment === 'contact-us' &&
            !this.isScrolled &&
            window.scrollY === 0
        )
      )
      .subscribe({
        next: () => {
          this.scrollToContactUs();
        },
      });
  }

  private scrollToContactUs() {
    this.isScrolled = true;

    (<HTMLDivElement>this.contactUsRef.nativeElement).scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }

  ngOnDestroy() {
    this.aboutUsScrollSubs?.unsubscribe();
  }
}
